<template>
  <main>
    <container-small>
      <background-wrapper src="hrdonates/header" ext="png">
        <div class="hero"/>
      </background-wrapper>
    </container-small>
    <text-container class="pt-5 pb-5" size="lg" justify-center>
      <h1 class="feature-title" v-html="$t(`Donates.joinUs.title`)" />
    </text-container>
    <ContentWithImageMd class="join-us pb-0 pb--md-5" src="hrdonates/join" image-order="1" image-order-sm="0" margin="0">
      <text-container>
        <p class="h-sub text-left" v-html="$t(`Donates.joinUs.text`)"/>
      </text-container>
    </ContentWithImageMd>
    <h1 class="feature-title mt-0 mt-md-5" v-html="$t(`Donates.features.title`)" />
    <b-row class="features justify-content-center" tag="ul">
      <b-col v-for="n in 3" :key="n" cols="12" md="6" lg="4" tag="li">
        <div class="feature mb-4">
          <img class="mb-2" :src="require(`@/assets/hrdonates/feature_${n}.svg`)">
          <h4 :class="['h1', bgColors[n]]">{{$t(`Donates.features.${n}.title`)}}</h4>
          <p>{{$t(`Donates.features.${n}.text`)}}</p>
        </div>
      </b-col>
    </b-row>
    <h1 class="feature-title pb-5 mb-5">{{$t(`Donates.commitments.title`)}}</h1>
    <ContentWithImage class="commitments" src="hrdonates/commitments" image-order="1" image-order-sm="0" margin="0">
      <text-container>
        <p class="h-sub text-left" v-html="$t(`Donates.commitments.text`)"/>
      </text-container>
    </ContentWithImage>
    <container-small>
      <background-wrapper class="mt-5 mb-5 pb-5">
        <h1 class="feature-title" v-html="$t(`Donates.merry.title`)" />
        <ContentWithImage class="merry pb-4" src="hrdonates/leadingwithhearts" image-order="0" image-order-sm="0" margin="0">
          <text-container>
            <p class="h-sub mb-0 text-left" v-html="$t(`Donates.merry.text`)"/>
          </text-container>
        </ContentWithImage>
        <h3 class="center pt-5 pb-3">{{$t(`Donates.pastSupport`)}}</h3>
        <div class="slider-wrapper">
          <VueSlickCarousel :arrows="true" v-bind="settings">
            <div v-for="n in 5" :key="n">
              <div class="interested-in-becoming-a-partner__image">
                <img :src="require(`@/assets/hrdonates/slide_${n}.png`)"/>
              </div>
            </div>
            <template #prevArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-left.svg">
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-right.svg">
              </div>
            </template>
          </VueSlickCarousel>
        </div>
      </background-wrapper>
      <h1 class="feature-title" v-html="$t(`Donates.support`)" />
      <div class="slider-wrapper">
        <VueSlickCarousel :arrows="true" v-bind="settings">
          <div v-for="n in 7" :key="n">
            <div class="interested-in-becoming-a-partner__image-2">
              <img :src="require(`@/assets/hrdonates/support_${n}.png`)"/>
            </div>
          </div>
          <template #prevArrow>
            <div class="custom-arrow">
              <img src="@/assets/arrow-left.svg">
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-arrow">
              <img src="@/assets/arrow-right.svg">
            </div>
          </template>
        </VueSlickCarousel>
      </div>
    </container-small>
    <background-wrapper class="mt-5" src="hrdonates/map" ext="png">
      <div class="map">
        <h1 class="feature-title text-center mb-2 mb-md-5" v-html="$t(`Donates.mapTitle`)"/>
        <b-row>
          <b-col cols="12" md="6">
            <p class="h-sub text-center text-md-left" v-html="$t(`Donates.mapText`)"/>
          </b-col>
          <b-col cols="12" md="6">
            <div class="contact-form-container">
              <template v-if="thankYou">
                <h3 class="text-center tall-bottom-padding">Thank you for your submission!</h3>
              </template>
              <template v-else>
                <div id="hrdonates_form" class="form-default">
                  <div class="form-row">
                    <div class="col required">
                      <label for="first_name">First Name</label>
                      <input v-model="form.firstName" type="text" class="form-control" required="" placeholder="First name" name="first_name" id="first_name">
                      <div v-if="errors.firstName" class="error">The field is required</div>
                    </div>
                    <div class="col required">
                      <label for="last_name">Last Name</label>
                      <input v-model="form.lastName" type="text" class="form-control" required="" placeholder="Last name" name="last_name" id="last_name">
                      <div v-if="errors.lastName" class="error">The field is required</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-8 required">
                      <label for="phone">Phone</label>
                      <input v-model="form.phone" type="tel" class="form-control" required="" placeholder="Phone" name="phone" id="phone">
                      <div v-if="errors.phone" class="error">The field is required</div>
                    </div>
                    <div class="col-4">
                      <label for="extension">Ext</label>
                      <input v-model="form.ext" type="number" class="form-control" placeholder="Ext" name="extension" id="extension">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col required">
                      <label for="email">E-mail</label>
                      <input v-model="form.email" type="email" class="form-control" required="" placeholder="E-mail" name="email" id="email">
                      <div v-if="errors.email" class="error">The field is required</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col required">
                      <label for="organization">Organization Name</label>
                      <input v-model="form.orgName" type="text" class="form-control" required="" placeholder="Organization Name" name="organization" id="organization">
                      <div v-if="errors.orgName" class="error">The field is required</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col required">
                      <label for="website">Website</label>
                      <input v-model="form.webSite" type="text" class="form-control" required="" placeholder="Website" name="website" id="website">
                      <div v-if="errors.webSite" class="error">The field is required</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col required">
                      <label for="additional_info">What do you do and how could we help?</label>
                      <textarea v-model="form.help" class="form-control" required="" name="additional_info" id="additional_info" placeholder="We love what we do and cannot wait to help you!" rows="3"></textarea>
                      <div v-if="errors.help" class="error">The field is required</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col text-center">
                      <button class="btn btn-primary mb-2" @click="sendEmail">Submit</button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <div class="map-mark">
      <b-row>
          <b-col cols="12" md="6">
            <img :src="require(`@/assets/hrdonates/map-mark.png`)"/>
            <h2 class="h1 feature-title text-center" v-html="$t(`Donates.mapMark`)"/>
          </b-col>
          <b-col cols="12" md="6"></b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import ContentWithImage from '@/components/ui/ContentWithImage.vue'
import ContentWithImageMd from '@/components/ui/ContentWithImageMd.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import axios from 'axios'

export default {
  name: 'HrDonates',
  components: {
    ContentWithImage,
    ContentWithImageMd,
    VueSlickCarousel
  },
  data () {
    return {
      bgColors: {
        1: 'bg-cyan',
        2: 'bg-purple',
        3: 'bg-blue'
      },
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        ext: '',
        email: '',
        orgName: '',
        webSite: '',
        help: ''
      },
      errors: {
        firstName: false,
        lastName: false,
        phone: false,
        email: false,
        orgName: false,
        webSite: false,
        help: false
      },
      thankYou: false
    }
  },
  computed: {
    isFormValid () {
      return !Object.keys(this.errors).some(k => this.errors[k])
    }
  },
  methods: {
    validEmail (email) {
      const re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
    showThankYou () {
      this.thankYou = true
    },
    validate () {
      this.errors.firstName = this.form.firstName.length === 0
      this.errors.lastName = this.form.lastName.length === 0
      this.errors.phone = this.form.phone.length === 0
      this.errors.email = !this.validEmail(this.form.email)
      this.errors.orgName = this.form.orgName.length === 0
      this.errors.webSite = this.form.webSite.length === 0
      this.errors.help = this.form.help.length === 0
    },
    sendEmail () {
      this.validate()
      if (this.isFormValid) {
        const emailBody = `
          First Name - ${this.form.firstName} \n
          Last Name - ${this.form.lastName} \n
          Phone - ${this.form.phone} \n
          Ext - ${this.form.ext} \n
          E-mail - ${this.form.email} \n
          Organization Name - ${this.form.orgName} \n
          Website - ${this.form.webSite} \n
          What do you do and how could we help? - ${this.form.help} \n
        `

        let data = new FormData()
        data.append('from', process.env['EMAIL_FROM'])
        data.append('to', process.env['MARKETING_ADDRESS'])
        data.append('subject', 'HRDownloads.com HR Donates Form Submission')
        data.append('body', emailBody)

        axios.post(`${process.env['CMS_DOMAIN']}/api/contact`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => {
            this.showThankYou()
          })
          .catch(err => console.log(err))
      }
    }
  }
}
</script>

<style lang="sass">
.commitments
  img
    max-width: 600px!important
    +media-breakpoint-down(xs)
      max-width: 540px!important

.join-us
  img
    max-width: 550px!important
    +media-breakpoint-down(sm)
      max-width: 500px!important
    +media-breakpoint-down(xs)
      max-width: 450px!important
.merry
  img
    max-width: 540px!important
    +media-breakpoint-down(xs)
      max-width: 420px!important
</style>

<style lang="sass" scoped>
.tall-bottom-padding
  padding-bottom: 500px

.error
  color: red
.center
  text-align: center
.slider-wrapper
  padding: 0 40px

.slick-prev
  +media-breakpoint-down(xxs)
    left: -5px

.slick-next
  +media-breakpoint-down(xxs)
    right: -10px

.slick-prev::before, .slick-next::before
  display: none

.center
  text-align: center

.hero
  padding: 400px 0
  +media-breakpoint-down(md)
    padding: 442px 0
  +media-breakpoint-down(xs)
    padding: 275px 0

.features
  margin-top: 50px
  margin-bottom: 120px
  padding: 0
  text-align: center
  list-style: none
  .feature
    display: flex
    flex-direction: column
    align-items: center
    margin: auto
    max-width: 400px
    h4
      padding: 0 10px
      &.bg-cyan
        background: #87E1D2
      &.bg-purple
        background: #CDBCF6
      &.bg-blue
        background: #7FC8FF
.feature-title
  text-align: center
  padding: 4rem 0 2rem
.interested-in-becoming-a-partner
  padding: 70px 0 170px
  +media-breakpoint-down(md)
    padding: 0 0 80px
  +media-breakpoint-down(sm)
    padding: 0 0 100px
  +media-breakpoint-down(xs)
    padding: 0 0 120px

  &__image,
  &__image-2
    display: flex
    align-items: center
    justify-content: center
    padding: 0 20px
    height: 100px
    width: 100%

    img
      max-height: 100%
      width: auto
      max-width: 100%

  &__image-2
    height: 200px

  &__slider
    margin: 40px auto 80px
    padding: 0 40px
    max-width: 1000px

  .custom-arrow
    color: $dark
    font-size: 14px
    height: 29px
    &:before
      content: none
.map
  padding: 60px 0

.contact-form-container
  max-width: 450px
  margin-left: auto
  +media-breakpoint-down(sm)
    margin: auto
    max-width: 500px
    width: 100%
  +media-breakpoint-down(xs)
    max-width: 90%

  .form-row
    margin-bottom: 25px
    label
      font-weight: bold
      letter-spacing: 0.2px
    .required label::after
      content: " *"
      color: red

.map-mark
  margin-top: -544px
  +media-breakpoint-only(lg)
    margin-top: -604px
  +media-breakpoint-only(md)
    margin-top: -644px
  +media-breakpoint-down(sm)
    margin-top: 0

  img
    display: block
    margin: 90px auto 0px
    max-width: 212px!important
</style>



// WEBPACK FOOTER //
// src/components/hrdonates/HrDonates.vue